import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Navbar.css";
import logo from "../../images/logo.png";
import {
  FaChevronDown,
  FaChevronRight,
  FaGraduationCap,
  FaBook,
  FaAward,
  FaStar,
  FaRegStar,
  FaLaptopCode,
  FaBookReader,
  FaChartLine,
  FaTrophy,
  FaSchool,
  FaComments,
  FaSnowflake,
  FaTools,
  FaWrench,
  FaCogs,
  FaBox,
  FaTshirt,
  FaHome

} from "react-icons/fa";

function Navbar() {
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [subDropdownOpen, setSubDropdownOpen] = useState(false);


const [homeAppliancesSubOpen, setHomeAppliancesSubOpen] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg crest-navbar sticky-top">
      <div className="container my-5 crest-navbar-container">
        <NavLink className="navbar-brand" to="/">
          <img src={logo} alt="Crestest Logo" className="crest-logo" />
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-controls="navbarNav"
          aria-expanded={mobileMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse justify-content-end ${mobileMenuOpen ? 'show' : ''}`} id="navbarNav">

          <ul className="navbar-nav align-items-lg-center">

            {/* Home */}
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/"
                end
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </NavLink>
            </li>

            {/* About */}
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/about"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </NavLink>
            </li>

            {/* --- Our Services Dropdown Menu --- */}
            <li
              className="nav-item dropdown crest-custom-dropdown"
              onMouseEnter={() => setServicesDropdownOpen(true)}
              onMouseLeave={() => {
                setServicesDropdownOpen(false);
                setHomeAppliancesSubOpen(false);
              }}
            >
              <button
                type="button"
                className={`nav-link dropdown-toggle-custom btn-reset ${window.location.pathname.startsWith("/services") ||
                    window.location.pathname.startsWith("/ac") ||
                    window.location.pathname.startsWith("/washing-machine")
                    ? "services-link-active"
                    : ""
                  }`}
                onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}
              >
                Our Services
                <FaChevronDown className="ms-1 dropdown-indicator-icon" />
              </button>

              {/* ================= FIRST LEVEL ================= */}
              <ul
                className={`crest-dropdown-menu ${servicesDropdownOpen ? "show-menu" : ""
                  }`}
              >

                {/* HOME APPLIANCES */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => setHomeAppliancesSubOpen(true)}
                  onMouseLeave={() => setHomeAppliancesSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setHomeAppliancesSubOpen(!homeAppliancesSubOpen);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">

                    <div className="d-flex align-items-center">

                      <span className="dropdown-icon-box accent-blue me-3">
                        <FaHome />
                      </span>

                      <span className="item-text">
                        Home Appliances
                      </span>

                    </div>

                    <FaChevronRight
                      className={`sub-indicator-icon ${homeAppliancesSubOpen ? "rotate-icon" : ""
                        }`}
                    />

                  </div>


                  {/* ================= SECOND LEVEL ================= */}
                  <ul
                    className={`crest-sub-dropdown-menu sub-dropdown-flip ${homeAppliancesSubOpen ? "show-submenu" : ""
                      }`}
                  >

                    {/* AC */}
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="/ac"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setHomeAppliancesSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >

                        <span className="dropdown-icon-box accent-blue me-3">
                          <FaSnowflake />
                        </span>

                        <span className="item-text">
                          AC
                        </span>

                      </a>
                    </li>


                    {/* WASHING MACHINE */}
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="/washing-machine"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setHomeAppliancesSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >

                        <span className="dropdown-icon-box accent-yellow me-3">
                          <FaTshirt />
                        </span>

                        <span className="item-text">
                          Washing Machine
                        </span>

                      </a>
                    </li>

                  </ul>

                </li>

              </ul>

            </li>


            {/* Customer Reviews */}
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/customer-reviews"
                onClick={() => setMobileMenuOpen(false)}
              >
                Customer Reviews
              </NavLink>
            </li>

            {/* Contact */}
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </NavLink>
            </li>

            {/* Get the App */}
            {/* <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
              <NavLink
                className="crest-login-btn"
                to="#"
                onClick={() => setMobileMenuOpen(false)}
                style={{ textDecoration: 'none'}}
              >
                Get the App
              </NavLink>
            </li> */}

          </ul>


        </div>
      </div>
    </nav>
  );
}

export default Navbar;